import { usersAreValid } from "@/helpers/user";
import { useEffect, useState } from "react";

const useAssistants = ({ quantity = 1, assistants: users = [], responsibleForAssistants = false }) => {
    const [assistants, setAssistants] = useState((() => {
        if (usersAreValid(users, quantity, responsibleForAssistants)) {
            return users;
        }

        return [...Array(parseInt(quantity))].map((_, index) => ({
            id: index + 1,
            name: '',
            lastname: '',
            rut: '',
            assumed_guest: false,
            is_autocomplete: false,
        }));
    })());

    const handleChangeAssistants = (event, index, options = {name: undefined, value: undefined, extra: []}) => {
        console.log({event})
        const id = index + 1;
        const assistant = assistants.find(assistant => assistant.id === id);
        const filteredUsers = assistants.filter(assistant => assistant.id !== id);

        const propName = options?.name !== undefined ? options?.name : event.target.name;

        const values = {
            'checkbox': Boolean(event.target.checked),
            'number': parseInt(event.target.value),
            'text': event.target.value,
            'default': event.target.value
        };

        const propValue = options?.value !== undefined ? options?.value : (values[event.target.type] || values['default']);

        const newAssistant = {
            ...assistant,
            id,
            [propName]: propValue,
        }

        if (options?.extra) {
            options?.extra.forEach(({ name, value }) => {
                newAssistant[name] = value;
            })
        }

        const newAssistants = [
            ...filteredUsers,
            newAssistant
        ]
        .sort((a, b) => {
            if (a.id > b.id) {
                return 1;
            }

            if (a.id < b.id) {
                return -1
            }

            return 0;
        });

        setAssistants(newAssistants);
    }

    useEffect(() => {
        if (quantity === 0) {
            setAssistants([]);
        }

        if (assistants.length > quantity) {
            const newAssistants = assistants;
            while (newAssistants.length !== quantity) {
                newAssistants.pop();
            }
            setAssistants(newAssistants);
        }

        if (assistants.length < quantity) {
            const newAssistants = assistants;
            while (newAssistants.length !== quantity) {
                newAssistants.push({
                    id: assistants.length + 1,
                    name: '',
                    lastname: '',
                    rut: '',
                    assumed_guest: false,
                    is_autocomplete: false
                });
            }
            setAssistants(newAssistants);
        }
    }, [quantity])

    return [assistants, handleChangeAssistants, setAssistants];
}

export default useAssistants;